import {memo, useCallback, useContext} from "react";
import {Link, LinkProps} from "react-router-dom";
import {GlobalContext} from "../../index";

interface Props extends LinkProps {
  to: any
}

const CustomLink = (props: Props) => {
  const {dispatch} = useContext<any>(GlobalContext)
  const handleClick = useCallback((e: any) => {
    if(!props.to || window.location.pathname === props.to) return e.preventDefault();
    e.stopPropagation();
    if(!e.metaKey) dispatch({isLoading: !props.target && true})
  }, [props.to, dispatch, props.target])

  return <Link {...props as LinkProps} onClick={handleClick} />
}

export default memo(CustomLink)
